import DotLoader from "react-spinners/DotLoader";
import ClipLoader from "react-spinners/ClipLoader";
import styled from "styled-components";

interface ILoaderProps {
    size: number;
    color: string;
    margin: number;
}

export const DotLoaderCommon = (props: ILoaderProps) => {
    return (
        <StyledLoader margin={props.margin} className="clip-loader">
            <DotLoader color={props.color} size={props.size} />
        </StyledLoader>
    );
};

/**
 * Peterpans loads with its own animated mark instead of a drawn spinner. The
 * asset only exists under `public-peterpans/`, so freelance keeps the ClipLoader
 * rather than pointing at an image it does not have.
 */
const isPeterpans = process.env.REACT_APP_FLAVOR === "peterpans";
const BRAND_SPINNER_SRC = "/images/Peterpans_Icon_200x200.gif";

export const ClipLoaderCommon = (props: ILoaderProps) => {
    return (
        <StyledLoader margin={props.margin} className="clip-loader">
            {isPeterpans ? (
                // `color` is ignored here on purpose: the mark carries its own
                // colours, and the prop stays in the signature so all 70-odd call
                // sites keep working unchanged.
                <BrandSpinner src={BRAND_SPINNER_SRC} alt="" $size={props.size} />
            ) : (
                <ClipLoader color={props.color} size={props.size} />
            )}
        </StyledLoader>
    );
};

const BrandSpinner = styled.img<{ $size: number }>`
    width: ${(props) => props.$size}px;
    height: ${(props) => props.$size}px;
    object-fit: contain;
`;

const StyledLoader = styled.div<{ margin: number }>`
    display: flex;
    justify-content: center;
    margin: ${(props) => `${props.margin}px`} auto;
    flex: 1;
`;
